require('./scheduleDirective');
require('../shared/teamLineup/teamLineupDirective');

'use strict';

angular.module('app.schedule', [
  'app.schedule.scheduleDirective',
  'app.shared.teamLineup.teamLineupDirective'
]).config([
  '$stateProvider',
  function ($stateProvider) {
    $stateProvider.state('app.schedule', {
      url: '/schedule?:type&:id&:scheduleSearch',
      templateUrl: 'components/schedule/scheduleView.html',
      reloadOnSearch: false,
      resolve: {
        searchTerm: [
          '$stateParams',
          function ($stateParams) {
            let term;
            if ($stateParams.type && $stateParams.id) {
              term = {
                type: $stateParams.type,
                search_id: $stateParams.id
              };
            }
            return term;
          }
        ]
      },
      params: {
        type: null,
        id: null,
        search: null,
        selected_favorites: null
      },
      controller: [
        '$scope', 'searchTerm',
        function ($scope, searchTerm) {
          $scope.searchTerm = searchTerm;
        }
      ],
      title: 'Schedule'
    });
  }
]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/schedule.js